import { z } from "zod";
import { dmaIngredientKindDtoSchema } from "../dma-domain";
import { dmaPhaseDtoSchema } from "../dma-domain/dma-phase.schema";
import { DmaSettingParameterKind } from "./dma-setting-parameter-kind.schema";
export const dmaSettingIngredientParameterDtoSchema = z.object({
    kind: z.literal(DmaSettingParameterKind.Ingredient),
    name: z.string(),
    ingredientKind: dmaIngredientKindDtoSchema,
    ingredientId: z.number(),
    phase: dmaPhaseDtoSchema,
});
